import React, { Component } from 'react'
import { connect } from 'react-redux'

import WithAuth from '../../../HOCs/WithAuth'
import LoadingScreen from '../../../components/LoadingScreen'

import ChartsList from './ChartsList'

import {
  getUnapprovedCharts,
  getChartsNeedingRevision,
  getApprovedCharts,
  getChartsNeedingVerificationForDataManager,
  // getChartsNeedingValidation,
 } from '../reducers/chartsReducer'

import '../style.css'


class ChartsListContainer extends Component {

  componentDidMount() {
    const pathName = this.props.routerProps.location.pathname
    if (pathName === '/charts/review') {
      return this.props.getUnapprovedCharts(this.props.alert)
    // } else if (pathName === '/charts/validate') {
    //   this.props.getChartsNeedingValidation(this.props.alert)
    } 
    
    if (pathName === '/charts/revise') {
      return this.props.getChartsNeedingRevision(this.props.alert)
    }

    if (pathName === '/charts/review-data-manager-notes' || pathName === '/charts/view-data-manager-notes') {
      return this.props.getChartsNeedingVerificationForDataManager(this.props.alert)
    }
  }

  getContext = () => {
    let fetchingCharts, charts

    const pathName = this.props.routerProps.location.pathname

    if (pathName === '/charts/review') {
      fetchingCharts = this.props.fetchingUnapprovedCharts
      charts = this.props.unapprovedCharts
    } else if (pathName === '/charts/revise') {
      fetchingCharts = this.props.fetchingChartsNeedingRevision
      charts = this.props.chartsNeedingRevision
    } else if (pathName === '/charts/review-data-manager-notes' || pathName === '/charts/view-data-manager-notes') {
      fetchingCharts = this.props.fetchingChartsNeedingVerificationForDataManager
      charts = this.props.chartsNeedingVerificationForDataManager
    // } else if (this.props.routerProps.location.pathname === '/charts/validate') {
    //   fetchingCharts = this.props.fetchingChartsNeedingValidation
    //   charts = this.props.chartsNeedingValidation
    }

    return { fetchingCharts, charts }
  }


  render() {
    const { type } = this.props

    const { fetchingCharts, charts } = this.getContext()

    let chartViewButtonText
    switch (type) {
      case "review":
        chartViewButtonText = "Review Chart"
        break;
      case "revise":
        chartViewButtonText = "Revise Chart"
        break;
      default:
        chartViewButtonText = "View Chart"
        break;
    }

    if (fetchingCharts) {
      return <LoadingScreen text="Loading Charts" />
    } else {
      return (
        <div className='ChartsContainer'>
          <ChartsList
            title={this.props.title}
            chartViewButtonText={chartViewButtonText}
            routerProps={this.props.routerProps}
            charts={charts}
          />
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    unapprovedCharts: state.chartsReducer.unapprovedCharts,
    fetchingUnapprovedCharts: state.chartsReducer.fetchingUnapprovedCharts,
    chartsNeedingRevision: state.chartsReducer.chartsNeedingRevision,
    fetchingChartsNeedingRevision: state.chartsReducer.fetchingChartsNeedingRevision,
    fetchingApprovedCharts: state.chartsReducer.fetchingApprovedCharts,
    approvedCharts: state.chartsReducer.approvedCharts,
    fetchingChartsNeedingVerificationForDataManager: state.chartsReducer.fetchingChartsNeedingVerificationForDataManager,
    chartsNeedingVerificationForDataManager: state.chartsReducer.chartsNeedingVerificationForDataManager,
    // fetchingChartsNeedingValidation: state.chartsReducer.fetchingChartsNeedingValidation,
    // chartsNeedingValidation: state.chartsReducer.chartsNeedingValidation,
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    getUnapprovedCharts: (alert) => dispatch(getUnapprovedCharts(alert)),
    getApprovedCharts: (alert) => dispatch(getApprovedCharts(alert)),
    getChartsNeedingRevision: (alert) => dispatch(getChartsNeedingRevision(alert)),
    getChartsNeedingVerificationForDataManager: (alert) => dispatch(getChartsNeedingVerificationForDataManager(alert)),
    // getChartsNeedingValidation: (alert) => dispatch(getChartsNeedingValidation(alert)),
  }
}

export default WithAuth(connect(mapStateToProps, mapDispatchToProps)(ChartsListContainer))
